import FBMultiAbnormalPaps from "./container/FBMultiAbnormalPapsLanding";

export default FBMultiAbnormalPaps;
